import { Container, Typography, Box, Grid, Hidden } from '@mui/material';
import Img1 from '../assets/images/section2/01.png';
import Img2 from '../assets/images/section2/02.png';
import Img3 from '../assets/images/section2/03.png';
import Img4 from '../assets/images/section2/04.png';
import Img5 from '../assets/images/section2/05.png';
import Img6 from '../assets/images/section2/06.png';
import Img7 from '../assets/images/section2/07.png';

import Img11 from '../assets/images/section2/subSection/01.png';
import Img21 from '../assets/images/section2/subSection/02.png';
import Img31 from '../assets/images/section2/subSection/03.png';
import Img41 from '../assets/images/section2/subSection/04.png';
import Img51 from '../assets/images/section2/subSection/05.png';
import Img61 from '../assets/images/section2/subSection/06.png';
import Img71 from '../assets/images/section2/subSection/07.png';
import bg from '../assets/images/section2/subSection/bg.png';
import Title from 'components/Title';
import { VscFlame } from 'react-icons/vsc';
import { LuVote } from 'react-icons/lu';
import { FaCircleHalfStroke } from 'react-icons/fa6';

const data = [
  {
    src: Img1,
    title: 'Voting Power Differences',
    isIcon: false
  },
  {
    src: Img2,
    title: 'Unlimited Supply',
    isIcon: false
  },
  {
    src: Img3,
    title: 'Inflationary Tokenomics',
    isIcon: false
  },
  {
    src: Img4,
    title: 'Poor Validator Rewards',
    isIcon: false
  },
  {
    src: Img5,
    title: 'Low Throughput',
    isIcon: false
  },
  {
    src: Img6,
    title: 'High Gas Fees',
    isIcon: false
  },
  {
    src: Img7,
    title: 'Lack of Decentralization',
    isIcon: false
  },
  {
    src: VscFlame,
    title: 'No Burning Mechanism',
    isIcon: true
  }
];

const data2 = [
  {
    src: Img11,
    title: 'Highest Level of Security',
    isIcon: false
  },
  {
    src: Img21,
    title: 'Democratic Governance',
    isIcon: false
  },
  {
    src: Img31,
    title: 'Stable Tokenomics',
    isIcon: false
  },
  {
    src: Img41,
    title: 'Fair Validator Rewards',
    isIcon: false
  },
  {
    src: Img51,
    title: 'High Throughput',
    isIcon: false
  },
  {
    src: Img61,
    title: 'Low Gas Fees',
    isIcon: false
  },
  {
    src: Img71,
    title: 'High Decentralization',
    isIcon: false
  },
  {
    src: (
      <LuVote
        style={{
          color: '#ca7729',
          fontSize: '70px'
        }}
      />
    ),
    title: 'Equal Validator Voting Power',
    isIcon: true
  },
  {
    src: (
      <FaCircleHalfStroke
        style={{
          color: '#ca7729',
          fontSize: '55px'
        }}
      />
    ),
    title: 'Halving In Every Four Years',
    isIcon: true
  },
  {
    src: (
      <VscFlame
        style={{
          color: '#ca7729',
          fontSize: '60px'
        }}
      />
    ),
    title: 'Burn Mechanism',
    isIcon: true
  }
];
const sections = [
  {
    title: 'POS',
    symbol: '+',
    description: 'Proof-of-Stake reduces energy consumption, builds scalability, and enhances network security.',
    align: 'flex-start'
  },
  {
    title: 'Halving',
    symbol: '+',
    description: 'Halving maintains long-term token scarcity and value.',
    align: 'flex-start'
  },
  {
    title: 'Burn Mechanism',

    description: 'Burn Mechanism consistently reduces token supply.',
    align: 'flex-start'
  }
];

const Section2 = () => {
  return (
    <>
      <Box sx={{ color: 'white', mt: { xs: 8, sm: 0 }, display: 'flex', justifyContent: 'center', pt: 2 }} pb={3}>
        <Container maxWidth="xl" sx={{ textAlign: 'center' }}>
          <Grid container justifyContent={'center'} alignItems={'flex-start'} sx={{ my: 8 }}>
            {sections.map((section, index) => (
              <Grid key={index} item xs={12} md={6} lg={3.5} container sx={{ justifyContent: section.align }}>
                <Box width="100%">
                  <Box sx={{ display: 'flex', justifyContent: 'space-between', width: '100%', alignItems: 'center' }}>
                    <Typography
                      variant="h4"
                      sx={{
                        fontSize: { xs: '30px', md: '48px' },
                        whiteSpace: 'pre'
                      }}
                    >
                      {section.title}
                    </Typography>
                    <Hidden mdDown>
                      {section.align !== 'flex-end' && section.symbol && (
                        <Typography
                          variant="h4"
                          sx={{
                            fontSize: '48px',
                            marginRight: '69px'
                          }}
                          display={'inline'}
                        >
                          {section.symbol}
                        </Typography>
                      )}
                    </Hidden>
                  </Box>
                  <Title
                    style={{ fontSize: '16px', textAlign: 'start' }}
                    variant={{ xs: 'h4', sm: 'h3', md: 'h2' }}
                    sx={{ letterSpacing: '0.05em', mb: { xs: 2, md: 5 }, textAlign: 'start', width: { xs: '100%', md: '70%' } }}
                  >
                    {section.description}
                  </Title>
                  <Hidden mdUp>
                    {section.align !== 'flex-end' && section.symbol && (
                      <Typography
                        variant="h4"
                        sx={{
                          fontSize: '48px'
                        }}
                        display={'inline'}
                      >
                        {section.symbol}
                      </Typography>
                    )}
                  </Hidden>
                </Box>
              </Grid>
            ))}
          </Grid>
          <Typography
            variant="h2"
            sx={{
              color: '#CA7729',
              fontSize: '45px'
            }}
          >
            Existing Layer-1 Blockchains Aren’t Fit For Mainstream Adoption
          </Typography>
          <Typography variant="body2" sx={{ fontSize: '18px', mt: 2, fontWeight: '500' }}>
            Existing Layer-1 blockchain networks face challenges that compromise the core principles of decentralization and inclusivity.
          </Typography>

          <Grid container sx={{ mt: 4, justifyContent: 'center' }} spacing={2}>
            {data?.map((item, idx) => (
              <Grid
                item
                xs={12}
                sm={4}
                lg={3}
                container
                sx={{ flexDirection: 'column', justifyContent: 'center', alignItems: 'center', p: 2 }}
                key={idx}
              >
                {item.isIcon ? (
                  <item.src
                    style={{
                      color: '#ca7729',
                      fontSize: '70px'
                    }}
                  />
                ) : (
                  <Box component={'img'} src={item.src} sx={{ width: '60px' }} />
                )}
                <Typography variant="h2" sx={{ mt: 2, width: '60%' }}>
                  {item.title}
                </Typography>
              </Grid>
            ))}
          </Grid>
        </Container>
      </Box>
      <Box sx={{ color: 'white', mt: { xs: 8, sm: 4 }, backgroundImage: `url(${bg})` }} pt={2} pb={3}>
        <Container maxWidth="xl" sx={{ textAlign: 'center' }}>
          <Typography
            variant="h2"
            sx={{
              color: '#CA7729',
              fontSize: '45px'
            }}
          >
            How Taral Addresses These Challenges?
          </Typography>
          <Typography variant="body2" sx={{ fontSize: '18px', mt: 2, fontWeight: '500' }}>
            Taral addresses the limitations in existing Layer-1 blockchains by seamlessly integrating the POS consensus mechanism with the
            world’s first dual deflationary model to create a secure, scalable, and sustainable blockchain ecosystem.
          </Typography>

          <Grid container sx={{ mt: 4, justifyContent: 'center' }} spacing={2}>
            {data2?.map((item, idx) => (
              <Grid
                item
                xs={12}
                sm={4}
                lg={2.2}
                container
                sx={{ flexDirection: 'column', justifyContent: 'space-between', alignItems: 'center', p: 2 }}
                key={idx}
              >
                {item.isIcon ? <>{item.src}</> : <Box component={'img'} src={item.src} sx={{ width: '60px' }} />}
                <Box sx={{ backgroundColor: 'orange', width: '100%', height: '100px' }}>
                  <Typography variant="h2" sx={{ mt: 2 }}>
                    {item.title}
                  </Typography>
                </Box>
              </Grid>
            ))}
          </Grid>
        </Container>
      </Box>
    </>
  );
};

export default Section2;
